import { ApolloClient, InMemoryCache } from '@apollo/client'
import { HEALTH_CLIENT_URL, V3_CLIENT_URL } from '../constants'

export const healthClient = new ApolloClient({
  // uri: 'https://api.thegraph.com/index-node/graphql',
  uri: HEALTH_CLIENT_URL,
  cache: new InMemoryCache(),
})

export const client = new ApolloClient({
  // uri: 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v3',
  uri: V3_CLIENT_URL,
  cache: new InMemoryCache({
    typePolicies: {
      Token: {
        // Singleton types that have no identifying field can use an empty
        // array for their keyFields.
        keyFields: false,
      },
      Pool: {
        // Singleton types that have no identifying field can use an empty
        // array for their keyFields.
        keyFields: false,
      },
    },
  }),
  queryDeduplication: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
})
